
import ProdutosService from "@/services/ProdutosService";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BannersCarousel from "../components/BannersCarousel.vue";
import LoaderContainer from "../components/Loader.vue";
import PaginatorComponent from "../components/Paginator.vue";
import FiltroOrdenacaoProdutos from "../components/produtos/filters/Ordenacao.filter.vue";
import ListaProdutos from "../components/produtos/ListaProdutos.vue";
import ProdutoCard from "../components/produtos/ProdutoCard.vue";
import ProdutoDetailsDialog from "../components/produtos/ProdutoDetailsDialog.vue";

const AppConfigStore = namespace("AppConfig");
const Auth = namespace("Auth");

@Component({
  name: "Home",
  components: {
    PaginatorComponent,
    ProdutoCard,
    ProdutoDetailsDialog,
    LoaderContainer,
    FiltroOrdenacaoProdutos,
    BannersCarousel,
    ListaProdutos,
  },
})
export default class Home extends Vue {
  @Prop({ default: "" }) page!: string;
  @Prop({ default: "" }) itemsPerPage!: string;
  @Prop({ default: "" }) sortId!: string;

  @Auth.Getter isLoggedIn!: boolean;

  isLoading = false;

  produtos = Promise.resolve([]);

  @AppConfigStore.Getter
  getImagensBanner!: Array<any>;

  @AppConfigStore.Getter
  getConfigsVisuais!: any;

  mounted() {
    this.produtos = this.fetchProdutos() as any;
  }

  @Watch("page")
  @Watch("itemsPerPage")
  @Watch("sortId")
  @Watch("isLoggedIn")
  onParameterChanged() {
    this.produtos = this.fetchProdutos() as any;
  }

  async fetchProdutos() {
    const page = parseInt(this.page) || 1;
    const itemsPerPage = parseInt(this.itemsPerPage) || 20;
    const sortId = this.sortId || "";

    let ordenacao = ProdutosService.listaOrdenacaoMap?.[sortId]?.ord;
    if (!ordenacao) ordenacao = { sortBy: ["produto.descricao_portal"] };

    return await ProdutosService.findAllCliente({
      paginacao: {
        page,
        itemsPerPage,
        sortBy: ordenacao?.sortBy,
        sortDesc: ordenacao?.sortDesc,
      },
      searchStr: "",
      filters: [],
    }).then((res) => ({
      data: res.data,
      totalrecordcount: res.totalrecordcount,
    }));
  }
}
